(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.searchToggle = this.querySelector('[data-search-toggle]');
      this.searchPanel = this.querySelector('#HeaderSearch');
      this.drawer = this.querySelector('#HeaderDrawer');

      this.searchToggle?.addEventListener('click', () => this.toggleSearch());
      this.querySelector('[data-drawer-open]')?.addEventListener('click', () => this.drawer.showModal());
      this.querySelector('[data-drawer-close]')?.addEventListener('click', () => this.drawer.close());
      this.drawer?.addEventListener('click', (event) => {
        if (event.target === this.drawer) this.drawer.close();
      });

      this.onKeydown = (event) => {
        if (event.key === 'Escape' && !this.searchPanel.hidden) this.toggleSearch(false);
      };
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('cart:updated', (event) => this.updateCount(event.detail?.item_count));
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
    }

    toggleSearch(force) {
      const open = force ?? this.searchPanel.hidden;
      this.searchPanel.hidden = !open;
      this.searchToggle.setAttribute('aria-expanded', String(open));
      if (open) this.searchPanel.querySelector('input[type="search"]').focus();
    }

    updateCount(count) {
      if (typeof count !== 'number') return;
      const badge = this.querySelector('[data-cart-count]');
      badge.textContent = count;
      badge.hidden = count === 0;
    }
  }

  if (!customElements.get('site-header')) customElements.define('site-header', SiteHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class CollectionPage extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 1280px)');
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('change', (event) => this.onChange(event));
      this.addEventListener('input', (event) => {
        if (event.target.matches('.facets__price-input')) {
          clearTimeout(this.priceTimer);
          this.priceTimer = setTimeout(() => this.refresh(this.formUrl()), 600);
        }
      });
      this.onPopState = () => this.refresh(window.location.href, false);
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
    }

    onClick(event) {
      const toggle = event.target.closest('[data-filter-toggle]');
      if (toggle) {
        if (this.desktop.matches) {
          const collapsed = this.toggleAttribute('data-collapsed');
          toggle.setAttribute('aria-expanded', String(!collapsed));
        } else {
          this.setDrawer(true);
        }
        return;
      }

      if (event.target.closest('[data-filter-close]')) {
        this.setDrawer(false);
        return;
      }

      const link = event.target.closest('[data-facet-link]');
      if (link) {
        event.preventDefault();
        this.refresh(link.href);
      }
    }

    onChange(event) {
      if (event.target.matches('[data-sort]')) {
        this.refresh(this.formUrl());
      } else if (event.target.matches('.facets__checkbox')) {
        this.refresh(this.formUrl());
      }
    }

    setDrawer(open) {
      this.toggleAttribute('data-filters-open', open);
      this.toggleAttribute('data-scroll-lock', open);
      const scrim = this.querySelector('.collection__scrim');
      if (scrim) scrim.hidden = !open;
    }

    formUrl() {
      const form = this.querySelector('[data-facets-form]');
      const params = new URLSearchParams(form ? new FormData(form) : undefined);
      for (const [key, value] of [...params.entries()]) {
        if (value === '') params.delete(key);
      }
      const sort = this.querySelector('[data-sort]');
      if (sort) params.set('sort_by', sort.value);
      return `${window.location.pathname}?${params.toString()}`;
    }

    async refresh(url, push = true) {
      const target = new URL(url, window.location.origin);
      const fetchUrl = new URL(target);
      fetchUrl.searchParams.set('section_id', this.dataset.sectionId);

      this.classList.add('is-loading');
      try {
        const html = await fetch(fetchUrl).then((response) => response.text());
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('collection-page');
        if (!fresh) return;

        ['[data-results]', '[data-facets]', '[data-collection-count]', '.collection__sidebar-apply'].forEach((selector) => {
          const current = this.querySelector(selector);
          const next = fresh.querySelector(selector);
          if (current && next) current.replaceWith(next);
        });

        if (push) window.history.pushState({}, '', `${target.pathname}${target.search}`);
      } catch (error) {
        window.location.href = target.href;
      } finally {
        this.classList.remove('is-loading');
      }
    }
  }

  if (!customElements.get('collection-page')) customElements.define('collection-page', CollectionPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-product-data]').textContent);
      this.form = this.querySelector('[data-product-form]');
      this.variantInput = this.querySelector('[data-variant-id]');
      const variantsScript = this.querySelector('[data-variants]');
      this.variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

      this.querySelectorAll('[data-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => this.showMedia(thumb.dataset.thumb));
      });

      this.querySelectorAll('[data-option-position]').forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange());
      });
      if (this.variants.length) this.markUnavailable();

      this.form?.addEventListener('submit', (event) => this.onSubmit(event));
    }

    showMedia(id) {
      if (!id) return;
      this.querySelectorAll('[data-media-id]').forEach((slide) => {
        slide.hidden = slide.dataset.mediaId !== String(id);
      });
      this.querySelectorAll('[data-thumb]').forEach((thumb) => {
        if (thumb.dataset.thumb === String(id)) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }

    selectedOptions() {
      return [...this.querySelectorAll('[data-option-position]:checked')].map((input) => input.value);
    }

    onOptionChange() {
      const selected = this.selectedOptions();
      const variant = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));
      this.markUnavailable();
      if (!variant) {
        this.setButton(false, this.data.unavailableLabel);
        return;
      }

      this.variantInput.value = variant.id;
      this.setButton(variant.available, variant.available ? this.data.addLabel : this.data.soldOutLabel);
      if (variant.featured_media) this.showMedia(variant.featured_media.id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      this.refreshPrice(variant.id);
    }

    markUnavailable() {
      const selected = this.selectedOptions();
      this.querySelectorAll('[data-option-position]').forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        const candidate = [...selected];
        candidate[position] = input.value;
        const match = this.variants.find((v) => v.options.every((value, i) => value === candidate[i]));
        input.classList.toggle('is-unavailable', !match || !match.available);
      });
    }

    async refreshPrice(variantId) {
      const price = this.querySelector('[data-price]');
      if (!price) return;
      const response = await fetch(`${this.dataset.productUrl}?variant=${variantId}&section_id=${this.dataset.sectionId}`);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = html.querySelector('[data-price]');
      if (fresh) price.innerHTML = fresh.innerHTML;
    }

    setButton(enabled, label) {
      const button = this.querySelector('[data-add-button]');
      if (!button) return;
      button.disabled = !enabled;
      button.querySelector('[data-add-label]').textContent = label;
    }

    async onSubmit(event) {
      if (this.data.redirectToCart) return;
      event.preventDefault();

      const button = this.querySelector('[data-add-button]');
      const label = button.querySelector('[data-add-label]');
      const error = this.querySelector('[data-form-error]');
      const original = label.textContent;
      button.setAttribute('aria-disabled', 'true');
      error.hidden = true;

      try {
        const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);

        const cart = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`).then((r) => r.json());
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        label.textContent = this.data.addedLabel;
        setTimeout(() => (label.textContent = original), 2000);
      } catch (e) {
        error.textContent = e.message;
        error.hidden = false;
      } finally {
        button.removeAttribute('aria-disabled');
      }
    }
  }

  if (!customElements.get('product-page')) customElements.define('product-page', ProductPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.recommendationsUrl) {
        this.loadRecommendations();
      }
      this.init();
    }

    init() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      this.prev?.addEventListener('click', () => this.scrollByPage(-1));
      this.next?.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      new ResizeObserver(() => this.update()).observe(this.track);
      this.update();
    }

    scrollByPage(direction) {
      const item = this.track.querySelector('li');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = item.getBoundingClientRect().width + gap;
      const visible = Math.max(1, Math.floor(this.track.clientWidth / step) - 1);
      this.track.scrollBy({ left: direction * step * visible, behavior: 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    }

    async loadRecommendations() {
      try {
        const response = await fetch(this.dataset.recommendationsUrl);
        const html = await response.text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('product-carousel');
        const track = fresh?.querySelector('[data-carousel-track]');
        if (track && track.children.length) {
          this.querySelector('[data-carousel-track]').replaceWith(track);
          this.init();
        } else {
          this.closest('.shopify-section')?.setAttribute('hidden', '');
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  if (!customElements.get('product-carousel')) customElements.define('product-carousel', ProductCarousel);

  } catch(e) { console.error(e); }
})();
})();
